// src/hooks/useForm.ts
import { useState } from 'react';

export const useForm = <T extends Record<string, any>>(initialState: T) => {
    const [values, setValues] = useState<T>(initialState);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setValues(prev => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (name: string) => {
    setValues(prev => ({ ...prev, [name]: !prev[name] }));
  };

  const handleSelectChange = (name: string, value: string) => {
    setValues(prev => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setValues(initialState);
  };

  return { values, setValues, handleChange, handleCheckboxChange, handleSelectChange, resetForm };
};